import { defineMessages } from 'react-intl-next';

type MessageDescriptorType = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	linkText: MessageDescriptorType;
	jiraLinkText: MessageDescriptorType;
	rovoIconAlt: MessageDescriptorType;
	chromeIconAlt: MessageDescriptorType;
	jiraIconAlt: MessageDescriptorType;
	dismissLabel: MessageDescriptorType;
} = defineMessages({
	linkText: {
		id: 'rovo-extension-install-cta-left-nav.link',
		defaultMessage: 'Get the browser extension',
		description: 'Text for rovo extension install cta link left nav',
	},
	jiraLinkText: {
		id: 'rovo-extension-install-cta-left-nav.jira-link',
		defaultMessage: 'Get the Rovo browser extension',
		description: 'Text for Jira left nav extension install CTA link',
	},
	rovoIconAlt: {
		id: 'rovo-extension-install-cta-left-nav.rovo-icon-alt',
		defaultMessage: 'Rovo Icon',
		description: 'Alt text for Rovo icon image',
	},
	chromeIconAlt: {
		id: 'rovo-extension-install-cta-left-nav.chrome-icon-alt',
		defaultMessage: 'Google Chrome Icon',
		description: 'Alt text for Google Chrome icon image',
	},
	jiraIconAlt: {
		id: 'rovo-extension-install-cta-left-nav.jira-icon-alt',
		defaultMessage: 'Jira Icon',
		description: 'Alt text for Jira icon image',
	},
	dismissLabel: {
		id: 'rovo-extension-install-cta-left-nav.dismiss-label',
		defaultMessage: 'Dismiss message',
		description: 'Label for dismiss button',
	},
});

type CopyVariationType = {
	heading: MessageDescriptorType;
	description: MessageDescriptorType;
};

export const COPY_VARIATIONS: {
	'copy-version-b': CopyVariationType;
	'copy-version-c': CopyVariationType;
	'jira-take-anywhere': CopyVariationType;
} = {
	'copy-version-b': defineMessages({
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
			defaultMessage: 'Get answers for work, anywhere',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
			defaultMessage:
				'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
			description: 'Description text for rovo extension install cta left nav',
		},
	}),
	'copy-version-c': defineMessages({
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
			defaultMessage: 'Unlock Rovo in every tab',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
			defaultMessage: '50K+ workers use it to chat with AI that understands their company.',
			description: 'Description text for rovo extension install cta left nav',
		},
	}),
	'jira-take-anywhere': defineMessages({
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.jira-take-anywhere',
			defaultMessage: 'Take Jira anywhere',
			description: 'Heading text for Jira left nav extension install CTA',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.jira-take-anywhere',
			defaultMessage:
				'Manage issues, get instant insights, and act on Jira from any tab in your browser.',
			description: 'Description text for Jira left nav extension install CTA',
		},
	}),
};
